import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/themes/terminal.css';
import './styles/themes/market.css';
import './styles/themes/dark.css';
import './styles/themes/mountain.css';
import './styles/themes/beach.css';
import './styles/themes/brat.css';
import './styles/index.css';
import './styles/readerPage.css';
import App from './App';
import { registerServiceWorker } from './registerServiceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker(); 